export default __webpack_public_path__ + "static/media/LUX_EMPODERADA.69eee42c.png";